import React, { Fragment } from 'react';
import { inject, observer } from 'mobx-react';

import { url } from 'js/services/Network';

import Container from './Container';
import Menu from './Menu';
import { MenuLink, MenuLabel } from './MenuLink';
import Chevron from './Chevron';

export default inject('page')(
  observer(({ page }) => {
    let stepsConstructed = -1;
  
    return (
    <Container>
      <Menu>
        {page.steps
          .map((step, index) => {
            if(!step.showStepMenu) return null;
            
            stepsConstructed++;
            return (
              <Fragment key={index}>
                {stepsConstructed > 0 && <Chevron />}
                {page.latestStep >= index ? (
                  <MenuLink
                    to={url(page.pageRoute, { ...page, step: step.name })}
                    highlight={page.currentStep === index ? 1 : 0}>
                    {step.label}
                  </MenuLink>
                ) : (
                  <MenuLabel>{step.label}</MenuLabel>
                )}
              </Fragment>
            )}
          )}
      </Menu>
    </Container>
  )
  }),
);
